/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  Whitelist,
  WhitelistInterface,
} from "../../../../contracts/libraries/Whitelist.sol/Whitelist";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnerUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "newWhitelist",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
    ],
    name: "WhitelistUpgraded",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "isAllowed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "user",
        type: "address[]",
      },
      {
        internalType: "bool[]",
        name: "val",
        type: "bool[]",
      },
    ],
    name: "setWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newWhitelist",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
    ],
    name: "triggerConsumers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type WhitelistConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: WhitelistConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Whitelist__factory extends ContractFactory {
  constructor(...args: WhitelistConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<Whitelist> {
    return super.deploy(overrides || {}) as Promise<Whitelist>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): Whitelist {
    return super.attach(address) as Whitelist;
  }
  override connect(signer: Signer): Whitelist__factory {
    return super.connect(signer) as Whitelist__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): WhitelistInterface {
    return new utils.Interface(_abi) as WhitelistInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Whitelist {
    return new Contract(address, _abi, signerOrProvider) as Whitelist;
  }
}
